module.exports = __webpack_public_path__ + "static/img/case01.b465146.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case01.jpg
// module id = me5i
// module chunks = 0